<template>
  <TContainer :mobile-full="true">
    <UCarousel v-slot="item" :items="cottages" :ui="cottageCarousel">
      <UCard
        as="a"
        :ui="carouselCardFourWithoutBorder"
        :href="item.item.url"
        @click.prevent="swiperClick(item.item.url)"
      >
        <TLazyimg
          :src="item.item.src"
          alt=""
          :classes-img="cardLazyImgRounded"
          classes="aspect-w-3 aspect-h-2"
        />
        <template #footer>
          <TStars
            class="pb-1"
            :comments="item.item.numComments"
            :stars="item.item.rate"
          />

          <TText variant="semibold" size="base" classes="mb-0">
            {{ item.item.name }}
          </TText>

          <TText size="base" color="text-gray-600" classes="mb-0">
            {{ item.item.province }}
          </TText>
        </template>
      </UCard>
    </UCarousel>
  </TContainer>
  <div class="my-5">
    <TContainer v-if="cta">
      <UButton
        :ui="mobileFullWidthButton"
        variant="solid"
        size="lg"
        :label="cta.text"
        :to="cta.link"
        external
        @click.prevent="buttonClick(cta.link)"
      />
    </TContainer>
  </div>
</template>
<script setup lang="ts">
import { cottageCarousel } from '~~/modules/design-system/utils/nuxt-ui-config/components/carousel'
import { carouselCardFourWithoutBorder } from '~~/modules/design-system/utils/nuxt-ui-config/components/card'
import { cardLazyImgRounded } from '~~/modules/design-system/components/t-lazyimg/constants/config'
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

export interface cottage {
  url: string
  src: string
  name: string
  province: string
  numComments: number
  rate: number
}
export interface propsInterface {
  cottages: cottage[]
  cta?: {
    text: string
    link: string
  }
}

defineProps<propsInterface>()
const emit = defineEmits(['swiper-click', 'button-click'])

const swiperClick = (url: string) => {
  emit('swiper-click')
  setTimeout(() => window.location.assign(url), 10)
}

const buttonClick = (url: string) => {
  emit('button-click')
  setTimeout(() => window.location.assign(url), 10)
}
</script>
